import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const environmentsSelector: ThemeUICSSObject = {
  '.environments': {
    'li.allEnvs': {
      variant: 'buttons.outline',
      py: 4,
      px: 5,
      gap: spacing(5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'initial',

      ':hover': {},
      '&:hover, &:focus': {},

      button: {
        p: spacing(0),

        '&.removeEnvironment': {
          transition: 'background-color 300ms ease-out, color 300ms ease-out',
          ':hover, :focus': {
            color: 'danger',
          },
          svg: {
            width: '1.25em',
            height: '1.25em',
          },
        },
      },
    },
  },
  /* PREPEND HERE */
};

export default environmentsSelector;
